// Small pub/sub for Masonry submit-success signals. The action handler
// is registered at module scope (see `register-emblem-actions.tsx`) so it
// can't consume React context; dirty-form guards subscribe from a hook
// and get notified synchronously before the success PUSH navigation.

type Listener = () => void;

const listeners = new Set<Listener>();

export const registerSubmitSuccessListener = (fn: Listener) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

export const notifyMasonrySubmitSuccess = () => {
  listeners.forEach((fn) => fn());
};
